export default __webpack_public_path__ + "static/annReading-54327ea85f25f9cc208091b35d92505d.png";